module.exports = __webpack_public_path__ + "static/media/revry-LOGOS.ca5533cc.png";